import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Box, Image, Flex } from 'atoms';
import downArrow from 'assets/down-arrow.svg';
import { InvoiceInfo, FilledDetails, InvoiceForm } from 'components/pages/collection';
import { setIsInvoiceOpen } from 'store/invoiceSlice';
import DelegateAvatar from 'assets/DelegateAvatar.svg';

const Container = styled(Box)`
	padding: 10px;
	margin: 1rem 0;
	border-radius: 5px;
	background-color: white;
`;

const StatusText = styled.span`
	font-size: 10px;
	font-weight: 600;
	color: ${(props) => (props.status === 'Pending' ? 'red' : 'green')};
`;

const Name = styled.span`
	font-size: 10px;
`;
const Time = styled.span`
	font-size: 10px;
`;

export default function InvoiceCard({ data, showArrow = true, isAssigned = false }) {
	const [isOpen, setIsOpen] = useState(false);
	const dispatch = useDispatch();

	function handleClick() {
		dispatch(setIsInvoiceOpen(!isOpen));
		// if (isFormOpen) {
		// 	dispatch(setIsFormOpen(false));
		// } else {
		// 	dispatch(setIsFormOpen(true));
		// }
		setIsOpen(!isOpen);
	}

	useEffect(
		() => () => {
			setIsOpen(false);
		},
		[]
	);

	return (
		<Container className="invoice-card-inner">
			<Flex
				flexDirection={data.delegated_salesman_name ? 'column' : 'row'}
				justifyContent="space-between"
				alignItems={!data.delegated_salesman_name && 'center'}
			>
				<InvoiceInfo data={data} viewOnly={isAssigned} />

				{showArrow && !data.delegated_salesman_name && (
					<Flex
						p="0 1rem"
						flexDirection="column"
						justifyContent="space-between"
						alignItems="center"
						cursor="pointer"
						onClick={handleClick}
						className="card-arrow-btn"
					>
						<Image
							src={downArrow}
							alt="downArrow"
							height={12}
							width={18}
							className={isOpen ? 'rotate' : 'reset-rotate'}
						/>
					</Flex>
				)}
			</Flex>
			{isOpen ? (
				<Box pt="2rem" pb=".5rem" textAlign="center">
					<InvoiceForm data={data} onClose={() => setIsOpen(false)} />
				</Box>
			) : (
				showArrow && <FilledDetails data={data} />
			)}
			{data?.delegated_salesman_name && (
				<Box mt="3">
					<Flex justifyContent="space-between">
						<div>
							<Image src={DelegateAvatar} alt="delegate" />
							<span> : </span>
							<Name> {data?.delegated_salesman_name}</Name>
							<Time> {`(${moment(data?.created_at).format('hh:mm')})`} </Time>
						</div>
						<div>
							<StatusText status={data?.delegated_status}>
								{data?.delegated_status}
							</StatusText>
						</div>
					</Flex>
				</Box>
			)}
		</Container>
	);
}

InvoiceCard.propTypes = {
	data: PropTypes.shape({
		verified_by_cashier_id: PropTypes.number,
		verified_by_segregator_id: PropTypes.number,
		status: PropTypes.string,
		billtype: PropTypes.string,
		delegated_salesman_name: PropTypes.string,
		delegated_salesman_first_name: PropTypes.string,
		delegated_salesman_last_name: PropTypes.string,
		delegated_status: PropTypes.string,
		created_at: PropTypes.any,
	}),
	showArrow: PropTypes.bool,
	isAssigned: PropTypes.bool,
};
